import React from 'react';
import { useDevelopmentDemo } from '../../contexts/DevelopmentDemoContext';
import type { Submission } from '../../types/developmentDemo';
import { formatTimestamp } from '../../utils/demoStorage';
import { glassPanel } from '../../utils/demoUi';
import { reviewForSubmission } from '../../utils/developmentDemo';
import { LevelBadge } from './DevBadges';
type ResponseRecordProps = {
  submission: Submission;
  /** Hide the response text when it is already shown nearby. */
  hideResponse?: boolean;
};
export function ResponseRecord({
  submission,
  hideResponse = false
}: ResponseRecordProps) {
  const {
    state,
    config
  } = useDevelopmentDemo();
  const review = reviewForSubmission(state, submission.id);
  const task = config.tasks[submission.round];
  return <article className={`${glassPanel} p-5 lg:p-6`} data-id="element-888" data-mp="16aeix16oirjn">
      <p className="flex flex-wrap gap-x-3 text-xs text-ink-muted" data-id="element-889" data-mp="1b8g3xrno10xr">
        <span className="font-mono font-semibold" data-id="element-890" data-mp="1f8ql80gwrdrx">{submission.id}</span>
        <span data-id="element-891" data-mp="1f6xdsiyh0piv">{submission.round === 'initial' ? 'Initial task' : 'Reassessment'}</span>
        <span data-id="element-892" data-mp="15xtovezm5j20">
          Task {task.id} · version 1
        </span>
        <span data-id="element-893" data-mp="10we3tmxfrcjm">{formatTimestamp(submission.at)}</span>
      </p>
      <h3 className="mt-1 font-heading font-bold text-ink-dark" data-id="element-894" data-mp="vyclx5bqxj9q">{task.title}</h3>
      {!hideResponse && <div className="mt-3 rounded-lg bg-surface-bg px-4 py-3" data-id="element-895" data-mp="qzhrf64f269s">
          <p className="text-xs font-semibold text-ink-muted" data-id="element-896" data-mp="r1cfgtaziei3">Response</p>
          <p className="mt-1 whitespace-pre-wrap leading-relaxed text-ink-dark" data-id="element-897" data-mp="1oloyqns3ucpu">{submission.response}</p>
        </div>}

      {review ? <div className="mt-5 border-t border-line pt-4" data-id="element-898" data-mp="1ex71ggj1anqy">
          <p className="text-xs text-ink-muted" data-id="element-899" data-mp="1evm5cmh2mwqz">
            <span className="font-mono font-semibold" data-id="element-900" data-mp="19ydkuf8gagmk">{review.id}</span> · {review.reviewerRole} · {formatTimestamp(review.at)} ·{' '}
            <span className={`font-semibold ${review.outcome === 'reviewed' ? 'text-navy' : 'text-amber-900'}`} data-id="element-901" data-mp="27ejaz9ycfqqd">
              {review.outcome === 'reviewed' ? 'Reviewed' : 'Revision requested'}
            </span>
          </p>
          <dl className="mt-3 space-y-3" data-id="element-902" data-mp="q0ui34p1ppn">
            {review.observations.map(observation => {
          const criterion = config.criteria.find(item => item.id === observation.criterionId);
          return <div key={observation.criterionId} className="grid grid-cols-1 gap-1 sm:grid-cols-[12rem_1fr] sm:gap-4" data-id="element-903" data-mp="3s3wwwnwa0i0a">
                  <dt className="text-sm font-semibold text-ink-dark" data-id="element-904" data-mp="3e3m3pe7hurby">{criterion?.label ?? observation.criterionId}</dt>
                  <dd data-id="element-905" data-mp="3i6s4w7fr1sbk">
                    <LevelBadge level={observation.level} data-id="element-906" data-mp="3i71ye5006hm0" />
                    <p className="mt-0.5 text-sm leading-relaxed text-ink-muted" data-id="element-907" data-mp="346r7j1yp130u">{observation.observation}</p>
                  </dd>
                </div>;
        })}
          </dl>
          <p className="mt-4 text-sm leading-relaxed text-ink-dark" data-id="element-908" data-mp="12e2xo9rjnhc3">
            <span className="font-semibold" data-id="element-909" data-mp="17dnzqt20g5t1">Feedback: </span>
            {review.feedback}
          </p>
          {review.openQuestions && <p className="mt-2 text-sm leading-relaxed text-ink-dark" data-id="element-910" data-mp="2rwrr7r244tez">
              <span className="font-semibold" data-id="element-911" data-mp="2mwvodv55j810">Open questions: </span>
              {review.openQuestions}
            </p>}
        </div> : <p className="mt-4 text-sm font-medium text-lavender" data-id="element-912" data-mp="31mukzth26bed">Awaiting review</p>}
    </article>;
}